import { TranslationKeys } from '../translations';

export function getTierLabel(
  tier: number | null | undefined,
  tierName: string | undefined,
  t: TranslationKeys,
): string {
  if (tier === 0) return t.tiers.free;
  if (tier != null && tierName) return tierName;
  if (tier === 1) return t.tiers.pro;
  if (tier === 2) return t.tiers.elite;
  if (tier != null) return t.tiers.tierN.replace('{level}', String(tier));
  return t.tiers.free;
}
